<template>
  <ms-dynamic-popup
    :maximum="true"
    :esc-to-close="escToClose"
    :title="titleVoucher"
    classTitle="b-u-transfer-deposit-detail"
    @beforeOpen="beforeOpen($event, close)"
    classDetail="transfer-deposit-detail"
    @beforeClose="beforeClose"
    @shortkeyAction="shortkeyAction"
  >
    <template v-slot:content-title>
      <div class="auto-gen">
        <ms-checkbox
          class="ml-2 mr-1"
          :disabled="viewing || this.isFromCompareConvert || offlineReady"
          v-model="isGenerateDrawSalary"
          @change="changeGenerateDrawSalary"
        ></ms-checkbox>
        <div class="">Tự động sinh chứng từ &nbsp;</div>
        <div class="title-text-bold">Chi tiền gửi trả lương</div>
      </div>
    </template>
    <template v-slot:icon>
      <ms-button
        text="Hướng dẫn"
        type="icon-button"
        class="btn-guide step-1"
        leftIcon="ic-guide"
        @click="guide"
        tooltipIconLeft="Hướng dẫn chức năng"
      />

      <ms-tour :steps="stepsDynamic" v-model:open="showStep" container=".transfer-deposit-detail"></ms-tour>

      <ms-button
        text="Phím tắt"
        tooltipIconLeft="Phím tắt"
        type="icon-button"
        class="btn-guide step-2"
        leftIcon="ic-shortkey"
        @click="clickShortkeyBtn"
      />

      <div
        class="button icon24 setting-small mr-2 step-3"
        :class="{'disabled-event': offlineReady}"
        v-tooltip="'Tùy chỉnh giao diện'"
        shortkey-target="ConfigLayout"
        @click="clickSettingLayout"
      ></div>
      <div class="button icon24 email mr-2" v-tooltip="'Email'" :class="{'disabled-event': offlineReady}"></div>

      <a
        target="_blank"
        :href="linkHelp($ms.constant.Help.BUTransferDeposit)"
        :class="{'disabled-event': offlineReady}"
      >
        <div class="button icon24 ic-question mr-2 step-4" v-tooltip="'Trợ giúp'" shortkey-target="Help"></div>
      </a>
    </template>
    <template v-slot:content>
      <div class="h-100 flex-column popup-container">
        <div class="amount-text">Tổng tiền</div>
        <div class="central-title">
          <div class="title-control-group" @click="toggleAboveHandler">Thông tin chung</div>
          <div class="amount-total">
            <div class="amount-value">
              {{
                $ms.format.formatData(totalAmountComputed, {
                  formatType: $ms.constant.FormatType.Amount,
                })
              }}
            </div>
          </div>
        </div>
        <!-- Bên trên -->
        <div class="above-container flex-row" v-show="toggleAbove">
          <div class="above-left flex">
            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Chương trình mục tiêu">CTMT</label>
              </div>
              <div class="control-right" v-if="offlineReady">
                <ms-combobox
                  :disabled="viewing || this.isFromCompareConvert"
                  class="flex mr-2"
                  valueField="project_id"
                  displayField="project_code"
                  v-model="model.project_id"
                  v-model:display="model.project_code"
                  @selected="
                    ({newData}) => {
                      selectedProject({newData}, this);
                    }
                  "
                  :initText="model.project_code"
                  :data="projectCombo"
                  :columns="projectColumns"
                  :dropdownWidth="600"
                  quickSearch="ProjectQuickSearch"
                  :quickSearchParam="quickSearchParam.Project"
                ></ms-combobox>
                <ms-input class="flex3" disabled v-model="model.project_name"></ms-input>
              </div>
              <div class="control-right" v-if="!offlineReady">
                <ms-combobox
                  :disabled="viewing || this.isFromCompareConvert"
                  quickAdd="TargetProgramDetail"
                  class="flex mr-2"
                  valueField="project_id"
                  displayField="project_code"
                  v-model="model.project_id"
                  v-model:display="model.project_code"
                  @selected="
                    ({newData}) => {
                      selectedProject({newData}, this);
                    }
                  "
                  :initText="model.project_code"
                  :data="comboboxDataRemote.project"
                  :columns="projectColumns"
                  :dropdownWidth="600"
                  :queryMode="'remote'"
                  quickSearch="ProjectQuickSearch"
                  :quickSearchParam="quickSearchParam.Project"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onProjectCommonComboboxLoadData(payload, null, {
                        dataField: 'project',
                      })
                  "
                ></ms-combobox>
                <ms-input class="flex3" disabled v-model="model.project_name"></ms-input>
              </div>
            </div>
            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label>Tài khoản chi</label>
              </div>
              <div class="control-right" v-if="offlineReady">
                <ms-combobox
                  :disabled="viewing"
                  class="flex mr-2"
                  valueField="bank_info_id"
                  displayField="bank_account"
                  v-model="model.bank_info_id"
                  v-model:display="model.bank_info_code"
                  @selected="
                    ({newData}) => {
                      selectedBank({newData}, this);
                    }
                  "
                  :initText="model.bank_info_code"
                  :data="bankInfoCombo"
                  :columns="bankColumns"
                  quickSearch="BankInfoQuickSearch"
                  :dropdownWidth="600"
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  :disabled="(viewing && !isQuickEditVoucher) || this.isFromCompareConvert"
                  v-model="model.bank_info_name"
                ></ms-input>
              </div>
              <div class="control-right" v-if="!offlineReady">
                <ms-combobox
                  :disabled="viewing"
                  quickAdd="BankInfoDetail"
                  class="flex mr-2"
                  valueField="bank_info_id"
                  displayField="bank_account"
                  v-model="model.bank_info_id"
                  v-model:display="model.bank_info_code"
                  @selected="
                    ({newData}) => {
                      selectedBank({newData}, this);
                    }
                  "
                  :initText="model.bank_info_code"
                  :data="comboboxDataRemote.bank"
                  :columns="bankColumns"
                  :queryMode="'remote'"
                  quickSearch="BankInfoQuickSearch"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onBankInfoComboboxLoadData(payload, null, {
                        dataField: 'bank',
                      })
                  "
                  :dropdownWidth="600"
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  :disabled="(viewing && !isQuickEditVoucher) || this.isFromCompareConvert"
                  v-model="model.bank_info_name"
                ></ms-input>
              </div>
            </div>

            <div class="flex-row control-group step-1">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label>Tài khoản nhận</label>
              </div>
              <div class="control-right" v-if="offlineReady">
                <ms-combobox
                  :disabled="viewing && !isQuickEditVoucher"
                  class="flex mr-2"
                  valueField="bank_account"
                  displayField="bank_account"
                  mapField="accounting_object_bank_account"
                  v-model="model.accounting_object_bank_account"
                  @selected="selectedAccountingObjectBank"
                  :initText="model.accounting_object_bank_account"
                  :data="bankInfoCombo"
                  :columns="bankColumns"
                  quickSearch="BankInfoQuickSearch"
                  :dropdownWidth="600"
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  :disabled="(viewing && !isQuickEditVoucher) || this.isFromCompareConvert"
                  v-model="model.accounting_object_bank_name"
                  :maxLength="255"
                ></ms-input>
              </div>
              <div class="control-right" v-if="!offlineReady">
                <ms-combobox
                  :disabled="viewing && !isQuickEditVoucher"
                  class="flex mr-2"
                  valueField="bank_account"
                  displayField="bank_account"
                  mapField="accounting_object_bank_account"
                  v-model="model.accounting_object_bank_account"
                  @selected="selectedAccountingObjectBank"
                  :initText="model.accounting_object_bank_account"
                  :data="comboboxDataRemote.bankAccount"
                  :columns="bankColumns"
                  :queryMode="'remote'"
                  quickSearch="BankInfoQuickSearch"
                  :remoteFilter="true"
                  @comboboxLoadData="
                    payload =>
                      onBankInfoComboboxLoadData(payload, null, {
                        dataField: 'bankAccount',
                      })
                  "
                  :dropdownWidth="600"
                ></ms-combobox>
                <ms-input
                  class="flex3"
                  :disabled="(viewing && !isQuickEditVoucher) || this.isFromCompareConvert"
                  v-model="model.accounting_object_bank_name"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>

            <div class="flex-row control-group">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Diễn giải">Diễn giải</label>
              </div>
              <div class="control-right">
                <ms-input
                  v-model="model.journal_memo"
                  :disabled="(viewing && !isQuickEditVoucher) || this.isFromCompareConvert"
                  :maxLength="255"
                ></ms-input>
              </div>
            </div>

            <div class="flex-row control-group" v-if="isShowVoucherReference">
              <div class="control-title" :class="{'control-title-small': this.dbOptions?.HeightOption == 1}">
                <label title="Diễn giải">Tham chiếu</label>
              </div>
              <div class="voucher-reference-list control-right align-item-center">
                <div class="voucher-reference" v-for="(item, index) in voucherReferenceItemsShow" :key="index">
                  <div class="voucher-reference-item" v-if="item.from_ref_no">
                    <div class="ref-no d-flex">
                      <a class="text-link" @click="showTargetLink(item)">{{ item.from_ref_no }}</a>
                      <label class="icon24 ic-remove" v-if="!viewing" @click="removeVoucherReference(item)"></label>
                    </div>
                  </div>
                </div>
                <!-- <label class="text-link more icon24" @click="showFormVoucherReference"></label> -->
              </div>
            </div>
          </div>
          <div class="above-right">
            <div class="seperator-line"></div>
            <div class="flex-row control-group mt-1">
              <div
                :class="[
                  'control-title-right',
                  {draw: model.withdraw_ref_date},
                  {'control-title-small': this.dbOptions?.HeightOption == 1},
                ]"
              >
                <label title="Ngày chứng từ">Ngày CT</label>
              </div>
              <div class="w-205px">
                <ms-datepicker
                  :disabled="viewing || this.isFromCompareConvert"
                  class="flex2"
                  v-model="model.ref_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                  @onBlurActionDatePicker="onBlurActionDatePicker(this)"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div
                :class="[
                  'control-title-right',
                  {draw: model.withdraw_ref_date},
                  {'control-title-small': this.dbOptions?.HeightOption == 1},
                ]"
              >
                <label title="Ngày hạch toán">Ngày HT</label>
              </div>
              <div class="w-205px">
                <ms-datepicker
                  :disabled="viewing || this.isFromCompareConvert"
                  class="flex2"
                  v-model="model.posted_date"
                  :tooltipIcon="'Chọn ngày tháng'"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                />
              </div>
            </div>
            <div class="flex-row control-group">
              <div
                :class="[
                  'control-title-right',
                  {draw: model.withdraw_ref_date},
                  {'control-title-small': this.dbOptions?.HeightOption == 1},
                ]"
              >
                <label title="Số chứng từ">Số CT</label>
              </div>
              <div class="w-205px">
                <ms-input
                  class="flex2"
                  :disabled="viewing || this.isFromCompareConvert"
                  v-model="model.ref_no"
                  :rules="[{name: $ms.constant.ValidateRule.Required}]"
                  :maxLength="20"
                />
              </div>
            </div>

            <div class="flex-row control-group" v-show="model.withdraw_ref_date">
              <div
                :class="[
                  'control-title-right',
                  {draw: model.withdraw_ref_date},
                  {'control-title-small': this.dbOptions?.HeightOption == 1},
                ]"
              >
                <label>Ngày giấy rút</label>
              </div>
              <div class="w-205px">
                <ms-datepicker class="flex2" v-model="model.withdraw_ref_date" disabled />
              </div>
            </div>

            <div class="flex-row control-group" v-show="model.withdraw_ref_no">
              <div
                :class="[
                  'control-title-right',
                  {draw: model.withdraw_ref_date},
                  {'control-title-small': this.dbOptions?.HeightOption == 1},
                ]"
              >
                <label>Số giấy rút</label>
              </div>
              <div class="w-205px">
                <ms-input class="flex2" v-model="model.withdraw_ref_no" disabled />
              </div>
            </div>

            <div class="flex-row control-group">
              <div
                :class="[
                  'control-title-right',
                  {draw: model.withdraw_ref_date},
                  {'control-title-small': this.dbOptions?.HeightOption == 1},
                ]"
              >
                <label title="Số cam kết chi">Số CKC</label>
              </div>
              <div class="w-205px">
                <ms-input
                  class="flex2"
                  :disabled="viewing || this.isFromCompareConvert"
                  v-model="model.bu_commitment_request_ref_no"
                  rightIcon="option-tab"
                  :isClickRightIcon="true"
                  @clickRightIcon="onClickCKC(this)"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Bên dưới -->
        <div class="under-container flex1">
          <div
            class="toggle-above"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="!toggleAbove"
            v-tooltip="'Mở rộng'"
          ></div>
          <div
            class="toggle-above"
            :class="{expand: toggleAbove}"
            :tabindex="-1"
            @click="toggleAboveHandler"
            v-if="toggleAbove"
            v-tooltip="'Thu nhỏ'"
          ></div>
          <ms-resize-screen isFlex class="flex-column flex">
            <template v-slot:content-master>
              <div class="toolbar-grid flex-between">
                <div class="content-left">
                  <div class="item-tabs" :class="{active: selectedTab == 1}" @click="selectedTabHandler(1)">
                    Hạch toán
                  </div>
                  <div class="item-tabs" :class="{active: selectedTab == 2}" @click="selectedTabHandler(2)">
                    Thống kê
                  </div>
                </div>

                <div class="flex-row flex-center">
                  <label class="label text-nowrap">Loại tiền</label>

                  <div class="ml-2 w100px">
                    <ms-combobox
                      :columns="currencyColumns"
                      valueField="currency_code"
                      displayField="currency_code"
                      ref="refCurrencyCode"
                      :data="comboboxDataRemote.currency"
                      v-model="model.currency_code"
                      :initText="model.currency_code"
                      @selected="selectCurrency"
                      @blur="assignValueCurrency"
                      :dropdownWidth="600"
                      :class="['input-editor', 'currency-combo']"
                      :queryMode="'remote'"
                      :remoteFilter="true"
                      @comboboxLoadData="onCurrencyComboboxLoadData"
                      :disabled="viewing || this.isFromCompareConvert || offlineReady"
                    ></ms-combobox>
                  </div>

                  <label
                    class="text-nowrap ml-2"
                    v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                    >Tỷ giá</label
                  >

                  <div
                    class="ml-2 w100px"
                    v-show="model.currency_code != $t('i18nEnum.Currency.VND') && model.currency_code"
                  >
                    <ms-number
                      v-model="model.exchange_rate"
                      :formatType="$ms.constant.FormatType.ExchangeRate"
                      :disabled="viewing"
                      @onActionBlur="onActionBlur"
                      :max="999999"
                    ></ms-number>
                  </div>
                </div>
              </div>
              <div class="flex d-flex">
                <ms-grid-editor
                  :disabled="viewing || this.isFromCompareConvert"
                  :data="model.Detail"
                  v-model:list="model.Detail"
                  :ref="refDetail"
                  class="flex-box"
                  idField="ref_detail_id"
                  formId="transfer-deposit-detail"
                  greyTitle
                  @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                  :propsData="propsData"
                  :footer="true"
                  @updateBusiness="changeDataBusiness"
                  @resizeStop="onResizeStop"
                  :changeTriggers="changeTriggers"
                  @onEditEventCellEditor="
                    (colIndex, rowIndex, $grid) => {
                      toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                    }
                  "
                  @copyDownRow="copyDownRow"
                  @copyActionClick="copyActionClick"
                  isCopyDataColumn
                  :lineBreak="this.dbOptions?.LineBreak ?? 1"
                  :configVoucherQuickEdit="configAccountingGrid"
                  :isQuickEditVoucher="isQuickEditVoucher"
                  :itemRightClicks="itemRightClicks"
                  @afterRightClickAction="viewAccount(this)"
                ></ms-grid-editor>
              </div>
            </template>
            <template v-slot:content-item>
              <div class="flex-column flex">
                <div class="toolbar-grid flex-between">
                  <div class="content-left">
                    <div class="item-tabs active">Hạch toán đồng thời</div>
                  </div>

                  <div class="flex-row flex-center">
                    <ms-button
                      type="icon-button"
                      leftIcon="update-down"
                      text="Cập nhật hạch toán đồng thời"
                      @click="generateParallel(true)"
                      :disabled="viewing || this.isFromCompareConvert"
                      class="update-btn"
                    />
                  </div>
                </div>
                <div class="flex d-flex">
                  <ms-grid-editor
                    formId="transfer-deposit-detail"
                    :disabled="viewing || this.isFromCompareConvert"
                    :data="model.Parallels"
                    v-model:list="model.Parallels"
                    ref="refDetailParallel"
                    class="flex-box"
                    idField="ref_detail_id"
                    greyTitle
                    :columns="columnsDataParalell"
                    :propsData="propsDataParalell"
                    @submitQuickAdd="() => onSubmitQuickAdd(...argurments, comboboxDataRemote)"
                    :footer="true"
                    @updateBusiness="changeDataBusiness"
                    :changeTriggers="changeTriggersHT"
                    @onEditEventCellEditor="
                      (colIndex, rowIndex, $grid) => {
                        toggleAboveHandlerGrid(colIndex, rowIndex, $grid, this);
                      }
                    "
                    :name="'gridParallel'"
                    @copyDownRow="copyDownRow"
                    @copyActionClick="copyActionClick"
                    isCopyDataColumn
                    :lineBreak="this.dbOptions?.LineBreak ?? 1"
                    :configVoucherQuickEdit="configParallelGrid"
                    :isQuickEditVoucher="isQuickEditVoucher"
                    :itemRightClicks="itemRightClicks"
                    @afterRightClickAction="viewAccount(this)"
                  ></ms-grid-editor>
                </div>
              </div>
            </template>
          </ms-resize-screen>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="h-100 flex-between flex1" style="flex-direction: row-reverse">
        <div>
          <div class="flex-row" v-if="!viewing" style="flex-direction: row-reverse">
            <ms-button
              text="Cất"
              class="step-close"
              v-tooltip="'Cất (Ctrl + S)'"
              shortkey-target="Save"
              @click="commandClick($ms.constant.Command.SaveView)"
            ></ms-button>
            <ms-button
              text="Hoãn"
              type="btn-custom"
              class="mr-footer-btn"
              v-tooltip="'Hoãn (Ctrl + U)'"
              shortkey-target="Postpone"
              @click="commandClick($ms.constant.Command.Postpone)"
              v-if="!viewing"
            ></ms-button>
          </div>
          <div class="flex-row" v-if="viewing">
            <ms-button
              text="Sửa"
              class="mr-footer-btn step-8-unposted"
              title="Sửa"
              type="btn-custom"
              v-tooltip="'Sửa (Ctrl + E)'"
              shortkey-target="Edit"
              v-if="this.isShowEditAndPosted"
              @click="onEditEvent"
            ></ms-button>
            <ms-button
              text="Ghi sổ"
              title="Ghi sổ (Ctrl + G)"
              class="step-close"
              v-if="this.isShowEditAndPosted"
              shortkey-target="Posted"
              @click="commandClick($ms.constant.Command.Posted)"
              :disabled="offlineReady"
            ></ms-button>
            <!-- start -->
            <div class="flex-row" v-if="this.isShowUnPosted && isQuickEditVoucher" style="flex-direction: row-reverse">
              <ms-button
                text="Cất"
                v-tooltip="'Cất (Ctrl + S)'"
                class="step-close"
                shortkey-target="Save"
                @click="commandClick($ms.constant.Command.SaveView)"
              ></ms-button>
              <ms-button
                text="Hoãn"
                type="btn-custom"
                class="mr-footer-btn"
                v-tooltip="'Hoãn (Ctrl + U)'"
                shortkey-target="Postpone"
                @click="commandClick($ms.constant.Command.Postpone)"
              ></ms-button>
            </div>
            <ms-button
              text="Sửa nhanh"
              title="Sửa nhanh"
              class="mr-footer-btn step-7-posted"
              type="btn-custom"
              v-if="this.isShowUnPosted && !isQuickEditVoucher"
              shortkey-target="QuickEdit"
              @click="eventQuickEditVoucher"
            ></ms-button>
            <!-- end -->
            <ms-button
              text="Bỏ ghi"
              title="Bỏ ghi (Ctrl + B)"
              class="step-close"
              v-if="this.isShowUnPosted && !isQuickEditVoucher"
              shortkey-target="UnPosted"
              @click="commandClick($ms.constant.Command.UnPosted)"
            ></ms-button>
          </div>
        </div>
        <div class="flex-row flex-center" v-if="!this.isFromCompareConvert">
          <ms-button
            leftIcon="refresh-white-big"
            type="btn-footer-helpful"
            text="Nạp"
            class="btn-opacity max-height pl-1"
            @click="refresh"
            v-tooltip="'Nạp (Ctrl + R)'"
            shortkey-target="Refresh"
            :disabled="this.editMode != this.$ms.constant.FormState.View || offlineReady"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-drop-down-button
            leftIcon="utilities-white-big"
            type="secondary-outline"
            text="Tiện ích"
            class="max-height step-5-pos"
            classCustom="btn-opacity"
            @menuClick="clickItemHandle"
            isBtnFooterHelpFul
            :menuItems="buttonTransferDeposit"
            :byDateClose="!this.isShowRefreshAndApprove"
          ></ms-drop-down-button>

          <div class="seperator-button"></div>

          <!-- Tạm thời disable nút in cho đến khi thi công chức năng In báo cáo -->
          <ms-drop-down-button
            leftIcon="print-white-big"
            type="secondary-outline"
            text="In"
            :isBtnPrint="true"
            @printPreviousReport="printPreviousReport"
            class="max-height step-6-pos"
            classCustom="btn-opacity"
            isBtnFooterHelpFul
            @menuClick="printItemCLick"
            :menuItems="!offlineReady ? printMenu : buttonPrints"
            :disabled="!viewing"
            :maxHeight="$t('i18nNumber.maxPrintHeight')"
          ></ms-drop-down-button>

          <div class="seperator-button" v-show="this.isShowRefreshAndApprove"></div>

          <ms-button
            leftIcon="approve-white-big"
            type="btn-footer-helpful"
            text="Duyệt"
            shortkey-target="Approve"
            class="btn-opacity max-height"
            :disabled="!viewing || isShowFromReport || offlineReady || stateApprove"
            @click="onApproveAction"
            v-show="this.isShowRefreshAndApprove"
          ></ms-button>
          <div class="seperator-button"></div>

          <ms-button
            leftIcon="ic-delete-voucher"
            type="btn-footer-helpful"
            text="Xóa"
            shortkey-target="Delete"
            class="btn-opacity max-height step-7-unposted"
            v-tooltip="'Xóa (Ctrl + D)'"
            :disabled="disabledDelete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
          ></ms-button>
          <button
            shortkey-target="Add"
            @click="clickItemHandle({command: 'ShowBUTransfer'})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="Duplicate"
            @click="clickItemHandle({command: $ms.constant.Command.Duplicate})"
            class="d-none"
            v-if="viewing"
          ></button>
          <button
            shortkey-target="CopyVoucher"
            @click="clickItemHandle({command: $ms.constant.Command.Copy})"
            class="d-none"
            v-if="!viewing"
          ></button>
          <button
            shortkey-target="ViewAccount"
            @click="clickItemHandle({command: $ms.constant.Command.ViewAccount})"
            class="d-none"
          ></button>
          <button
            shortkey-target="Delete"
            @click="clickItemHandle({command: $ms.constant.Command.Delete})"
            class="d-none"
            v-if="viewing && !model.is_posted && this.isShowRefreshAndApprove"
          ></button>
        </div>
        <div class="flex-row">
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            leftIcon="left-arrow-white"
            :disabled="!currentIndexBack || offlineReady"
            v-tooltip="'Trước'"
            class="mr-1"
            shortkey-target="ArrowLeft"
            @click="commandClick($ms.constant.Command.BackVoucher)"
          ></ms-button>
          <ms-button
            type="btn-custom"
            v-if="viewing && this.isShowRefreshAndApprove && !this.isFromCompareConvert"
            shortkey-target="ArrowRight"
            leftIcon="right-arrow-white"
            :disabled="!currentIndexNext || offlineReady"
            v-tooltip="'Sau'"
            @click="commandClick($ms.constant.Command.NextVoucher)"
            class="mr-1"
          ></ms-button>
          <ms-button
            text="Đóng"
            v-tooltip="'Đóng (Ctrl + Q)'"
            shortkey-target="Quit"
            type="btn-custom"
            @click="hide"
            class="mr-2"
          ></ms-button>
        </div>
      </div>
    </template>
  </ms-dynamic-popup>
</template>

<script>
import msDynamicPopup from '@/components/popup/MsDynamicPopup.vue';
import msGridEditor from '@/components/gridEditor/MsGridEditor.vue';
import baseDetailVoucher from '@/views/base/baseDetailVoucher';
import baseDetail from '@/views/base/baseDetail';
import {ModuleBUTransfer, ModuleBuPlanWithDraw} from '@/stores/moduleConst';
import {useBUTransferDepositDetailData} from './BUTransferDepositDetailData.js';
import {useComboboxColumns} from '@/commons/combobox/comboboxColumns';
import {ModuleContext} from '@/stores/moduleConst';
import {mapGetters} from 'vuex';
import {showConfirm, showError} from '@/commons/globalMessage';
import {useCurrencyCombo} from '@/commons/combobox/CurrencyCombo.js';
import {useCurrencyShowColumn} from '@/commons/gridColumn/CurrencyShowColumn.js';
import {useInitActionCombo} from '../../../commons/combobox/initActionCombo.js';
import {useActionGridEditor} from '@/commons/gridColumn/ActionGridEditor.js';
import {useInforCommons} from '../../utility/commons/inforCommons.js';
import popupUtil from '@/commons/popupUtil';
import buPlanWithDrawAPI from '@/apis/bu/buPlanWithDrawAPI.js';
import {useActionParallel} from '@/commons/gridColumn/ActionParallel.js';
import baWithdrawAPI from '@/apis/ba/baWithdrawAPI.js';
import moment from 'moment';
import RefType from '@/commons/wildcards/constants/RefType.js';
import {useCacheComboConfig} from '@/commons/combobox/cacheCombo/cacheComboConfig.js';
import {useCacheAccountComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountComboConfig.js';
import {useCacheBudgetSourceComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetSourceComboConfig.js';
import {useCacheBudgetChapterComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetChapterComboConfig.js';
import {useCacheBudgetKindItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetKindItemComboConfig.js';
import {useCacheBudgetItemComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetItemComboConfig.js';
import {useCacheProjectComboConfig} from '@/commons/combobox/cacheCombo/cacheProjectComboConfig.js';
import {useCacheAccountingObjectComboConfig} from '@/commons/combobox/cacheCombo/cacheAccountingObjectComboConfig.js';
import {useCacheActivityComboConfig} from '@/commons/combobox/cacheCombo/cacheActivityComboConfig.js';
import {useCacheStatisticComboConfig} from '@/commons/combobox/cacheCombo/cacheStatisticComboConfig.js';
import {useCacheBankInfoComboConfig} from '@/commons/combobox/cacheCombo/cacheBankInfoComboConfig.js';
import {useCacheContractComboConfig} from '@/commons/combobox/cacheCombo/cacheContractComboConfig.js';
import {useCacheTopicComboConfig} from '@/commons/combobox/cacheCombo/cacheTopicComboConfig.js';
import {useCacheTaskComboConfig} from '@/commons/combobox/cacheCombo/cacheTaskComboConfig.js';
import {useCacheBudgetProvideComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetProvideComboConfig.js';
import {useCacheFundStructureComboConfig} from '@/commons/combobox/cacheCombo/cacheFundStructureComboConfig.js';
import {useCacheFundComboConfig} from '@/commons/combobox/cacheCombo/cacheFundComboConfig.js';
import {useCacheBudgetFeesComboConfig} from '@/commons/combobox/cacheCombo/cacheBudgetFeesComboConfig.js';
import MsTour from '@/components/tour/MsTour.vue';
import {useValidateBudgetSourceAccount} from '@/views/utility/commons/validateBudgetSourceAccount.js';
import {useCopyNewVoucher} from '@/views/utility/commons/copyNewVoucher.js';
import msResizeScreen from '@/components/resize-wrapper/MsResizeScreen.vue';
import {reactive, ref, getCurrentInstance, computed, defineProps, onMounted, shallowRef} from 'vue';
import bUTransferAPI from '@/apis/bu/bUTransferAPI.js';
import {ModuleOfflineWork} from '@/stores/moduleConst';
import commonFunction from '@/commons/commonFunction.js';

export default {
  components: {
    msDynamicPopup,
    msGridEditor,
    MsTour,
    msResizeScreen,
  },
  extends: baseDetailVoucher,
  name: 'BUTransferDepositDetail',

  setup: props => {
        /** Cache lại param khi refresh */
    const isCacheParam = true;
    const titleCode = 'detail_popup_butransferdepositdetail';
    const {proxy} = getCurrentInstance();
    const module = ModuleBUTransfer;
    let layoutTagDetail = ref('BUTransferDepositDetail');
    const currentLayout = ref('BUTransferDepositDetail');
    const isGenerateDrawSalary = ref(true);
    const quickAddMultiItems = ref([
      {
        valueField: 'CustomerVendorDetail',
        displayField: 'Khách hàng, nhà cung cấp',
      },
      {
        valueField: 'EmployeeDetail',
        displayField: 'Cán bộ',
      },
    ]);

    // NHCUONG 23.06.2023: Các thông tin cho chứng từ tham chiếu
    const isShowVoucherReference = ref(false);
    const voucherReferenceItems = ref([]);
    const refTypeAcceptVoucherReference = ref([
      proxy.$ms.constant.RefType.CAReceiptPlanWithdraw,
      proxy.$ms.constant.RefType.CAPayment,
      proxy.$ms.constant.RefType.CAPaymentPurchase,
      proxy.$ms.constant.RefType.CAPaymentFixedAsset,
      proxy.$ms.constant.RefType.CAPaymentVendor,
      proxy.$ms.constant.RefType.BAWithDraw,
      proxy.$ms.constant.RefType.BAWithdrawPurchase,
      proxy.$ms.constant.RefType.BAWithDrawFixedAsset,
      proxy.$ms.constant.RefType.BAWithdrawVendor,
      proxy.$ms.constant.RefType.GLGeneralVoucher,
      proxy.$ms.constant.RefType.BUTransferDeposit,
    ]);

    var hideCheckboxGenerateDrawSalary = ref(false);

    /**
     * Cấu hình ref grid để base đọc
     */
    proxy._gridDetails = {
      Detail: 'refDetail',
      Parallels: 'refDetailParallel',
    };

    const {projectColumns, bankColumns, accountColumns, currencyColumns} = useComboboxColumns();

    // Khởi tạo dữ liệu
    const {
      buttonTransferDeposit,
      buttonPrints,
      comboboxDataRemote,
      columnParallel,
      toggleAbove,
      toggleAboveHandler,
      selectedTab,
      budgetSourceComboConfig,
      budgetChapterComboConfig,
      budgetSubKindItemComboConfig,
      budgetItemComboConfig,
      budgetKindItemComboConfig,
      budgetSubItemComboConfig,
      accountComboMostDetailConfig,
      budgetDetailItemComboConfig,
      projectComboConfig,
      accountingObjectComboConfig,
      activityComboConfig,
      statisticComboConfig,
      bankAccountComboConfig,
      contractComboConfig,
      topicComboConfig,
      TaskComboConfig,
      budgetProvideComboConfig,
      fundStructureComboConfig,
      typeOfFundComboConfig,
      submitQuickAdd,
      comboboxLoadData,
      accountComboParalellConfig,
      budgetFeesComboConfig,
    } = useBUTransferDepositDetailData();

    const {onBankInfoComboboxLoadData, onProjectCommonComboboxLoadData, projectExpenseComboConfig} = useInitActionCombo(
      comboboxDataRemote,
      comboboxLoadData,
    );

    const subSystemCode = proxy.$ms.constant.SubSystemCode.BUTransfer;

    //Param dùng cho form tìm nhanh
    const quickSearchParam = reactive({
      Project: {
        isFilter: true,
        filterFunc: x => x.inactive == false && !x.is_parent && x.object_type == 1,
      },
    });

    /**
     * Config sửa nhanh chứng từ
     */
    const configAccountingGrid = [
      'description',
      'statistic_code',
      'topic_code',
      'fund_code',
      'fund_structure_name',
      'task_code',
      'is_source_before_year',
      'activity_name',
      'note',
      'contract_no',
      'project_activity_id', //hoạt động dự án
      'project_expense_id', //khoản chi dự án
      'project_expense_code',
    ];

    const configParallelGrid = ['description'];

    /**
     * Click chọn tab hạc toán. thống kế thì đổi layout để load lại
     * NXCHIEN 12.06.2022
     */
    const selectedTabHandler = value => {
      switch (value) {
        case 1:
          layoutTagDetail.value = 'BUTransferDepositDetail';
          currentLayout.value = 'BUTransferDepositDetail';
          break;
        case 2:
          layoutTagDetail.value = 'BUTransferDepositDetailSta';
          currentLayout.value = 'BUTransferDepositDetailSta';
          break;
      }
      selectedTab.value = value;
    };

    // Combo TK nợ, có
    const {
      cacheAccountDebitCombo,
      cacheAccountCreditCombo,
      cacheAccountDebitParalellCombo,
      cacheAccountCreditParalellCombo,
    } = useCacheAccountComboConfig();

    cacheAccountDebitCombo.modelValueField = 'debit_account';
    cacheAccountCreditCombo.modelValueField = 'credit_account';
    cacheAccountDebitParalellCombo.modelValueField = 'debit_account';
    cacheAccountCreditParalellCombo.modelValueField = 'credit_account';
    // Combo nguồn
    const {cacheBudgetSourceComboConfig} = useCacheBudgetSourceComboConfig();
    // Combo chương
    const {cacheBudgetChapterComboConfig} = useCacheBudgetChapterComboConfig();
    // Combo loại, khoản
    const {cacheBudgetKindItemComboConfig, cacheBudgetSubKindItemComboConfig} = useCacheBudgetKindItemComboConfig();
    // Combo mục tiểu mục tiết tiểu mục
    const {
      cacheBudgetItemComboConfig,
      cacheBudgetSubItemComboConfig,
      cacheBudgetDetailItemComboConfig,
    } = useCacheBudgetItemComboConfig();
    // Combo dự án
    const {cacheProjectComboConfig, projectCombo} = useCacheProjectComboConfig();
    // Combo hoạt động
    const {cacheActivityComboConfig} = useCacheActivityComboConfig();
    // Combo mã thống kê
    const {cacheStatisticComboConfig} = useCacheStatisticComboConfig();
    // Combo TK NH,KB
    const {cacheBankInfoComboConfig, bankInfoCombo} = useCacheBankInfoComboConfig();
    // Combo hợp đồng
    const {cacheContractComboConfig} = useCacheContractComboConfig();
    // Combo đề tài
    const {cacheTopicComboConfig} = useCacheTopicComboConfig();
    // Combo nhiệm vụ
    const {cacheTaskComboConfig} = useCacheTaskComboConfig();
    // Combo mã dự phòng
    const {cacheBudgetProvideComboConfig} = useCacheBudgetProvideComboConfig();
    // Combo cấp phát
    const {cacheFundStructureComboConfig} = useCacheFundStructureComboConfig();
    // Combo loại quỹ
    const {cacheFundComboConfig} = useCacheFundComboConfig();
    // Combo phí, lệ phí
    const {cacheBudgetFeesComboConfig} = useCacheBudgetFeesComboConfig();

    // Cấu hình các field của grid
    const propsData = {
      org_ref_no: {
        maxLength: 200,
      },
      description: {
        maxLength: 255,
      },
      note: {
        maxLength: 255,
      },
      inv_no: {
        maxLength: 20,
      },
      amount: {
        max: 10000000000000000000,
      },
      budget_source_name: cacheBudgetSourceComboConfig,
      budget_chapter_code: cacheBudgetChapterComboConfig,
      budget_sub_kind_item_code: cacheBudgetSubKindItemComboConfig,
      budget_kind_item_code: cacheBudgetKindItemComboConfig,
      budget_item_code: cacheBudgetItemComboConfig,
      budget_sub_item_code: cacheBudgetSubItemComboConfig,
      budget_detail_item_code: cacheBudgetDetailItemComboConfig,
      debit_account: cacheAccountDebitCombo,
      credit_account: cacheAccountCreditCombo,
      method_distribute_name: {
        enum: 'MethodDistributeType',
        modelValueField: 'method_distribute_type',
        dropdownWidth: 200,
      },
      cash_withdraw_type_name: {
        enum: 'CashWithDrawType',
        modelValueField: 'cash_withdraw_type_id',
        dropdownWidth: 300,
      },
      project_code: cacheProjectComboConfig,
      accounting_object_code: accountingObjectComboConfig,
      activity_name: cacheActivityComboConfig,
      statistic_code: cacheStatisticComboConfig,
      bank_account: cacheBankInfoComboConfig,
      contract_no: cacheContractComboConfig,
      topic_code: cacheTopicComboConfig,
      task_code: cacheTaskComboConfig,
      budget_provide_code: cacheBudgetProvideComboConfig,
      fund_structure_name: cacheFundStructureComboConfig,
      fund_code: cacheFundComboConfig,
      budget_fees_code: cacheBudgetFeesComboConfig, //Phí,lệ phí
      project_expense_code: projectExpenseComboConfig,
      rowAction: ['Insert', 'Delete'],
    };

    // config grid hạch toán đồng thời
    var propsDataParalell = Object.assign({}, propsData);
    propsDataParalell.debit_account = cacheAccountDebitParalellCombo;
    propsDataParalell.credit_account = cacheAccountCreditParalellCombo;

    /**
     * ghi đè lại hàm trước khi mở form
     * tvhien 08.11.2022
     */
    function beforeOpen($event, close) {
      proxy.super('beforeOpen', baseDetailVoucher, $event, close);
      // lấy dữ liệu tự động in trong cache
      isGenerateDrawSalary.value = JSON.parse(
        proxy.$ms.commonFn.getLocalStorage('IsGenerateDrawSalary')
          ? proxy.$ms.commonFn.getLocalStorage('IsGenerateDrawSalary')
          : false,
      );
    }

    /**
     * Override để lấy thêm dữ liệu chứng từ khi mở form và gán giá trị mặc định 1 số trường
     * NXCHIEN 06.04.2022
     */
    async function bindData(data) {
      data.total_amount = data.total_amount || 0;
      data.increment_ref_no = null;

      data.posted_date = data.posted_date || proxy.postedDate;
      data.ref_date = data.ref_date || proxy.postedDate;

      data.currency_code = data.currency_code || proxy.$t('i18nEnum.Currency.VND');
      data.exchange_rate = data.exchange_rate || 1;

      currencyCode.value = data.currency_code;

      // NHCUONG 23.06.2023: Bổ sung thêm chứng từ tham chiếu
      if (data.VoucherReferences && data.VoucherReferences.length > 0) {
        voucherReferenceItems.value = [...data.VoucherReferences];
      } else {
        voucherReferenceItems.value = [];
      }

      // Check nếu là sinh chứng từ từ Rút dự toán tiền gửi thì ẩn checkbox sinh chứng từ trả lương NHANH3 24.07.2023
      if (data && data.withdraw_ref_id && !proxy?.offlineReady) {
        var isGenerateBUPlanWithdrawDeposit = await bUTransferAPI.CheckGenerateBUPlanWithdrawDeposit(
          data.withdraw_ref_id,
        );
        if (isGenerateBUPlanWithdrawDeposit) {
          hideCheckboxGenerateDrawSalary.value = true;
          isGenerateDrawSalary.value = false;
        }
      }
      if ((!data.withdraw_ref_id || !isGenerateBUPlanWithdrawDeposit) && !proxy?.offlineReady) {
        hideCheckboxGenerateDrawSalary.value = false;
        if (JSON.parse(proxy.$ms.commonFn.getLocalStorage('IsGenerateDrawSalary'))) {
          isGenerateDrawSalary.value = true;
        }
      }
      // Nếu làm offline => ẩn chức năng sinh chứng từ
      if (proxy?.offlineReady) {
        hideCheckboxGenerateDrawSalary.value = true;
        isGenerateDrawSalary.value = false;
        data.ref_type = data.ref_type ?? proxy.$ms.constant.RefType.BUTransferDeposit;
        if (!data.total_tax_amount) {
          data.total_tax_amount = 0; // TH không có thì gắn giá trị mặc định
        }
      }
      proxy.super('bindData', baseDetailVoucher, data);
      // sinh hạch toán đồng thời
      if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
        await proxy.generateParallel(true, true);
        assignDataEmptyToParallel(proxy);
      }
      proxy.super('setOldDataItem', baseDetailVoucher, proxy.model);
      if (proxy.viewing) {
        if (proxy.model.is_posted) {
          stepsDynamic.value = steps.value.filter(x => x.state.includes('posted') || x.state.includes('default'));
        } else {
          stepsDynamic.value = steps.value.filter(x => x.state.includes('unposted') || x.state.includes('default'));
        }
      } else {
        stepsDynamic.value = steps.value.filter(x => x.state.includes('edit') || x.state.includes('default'));
      }
    }

    const voucherReferenceItemsShow = computed(() => {
      return voucherReferenceItems.value.filter((item, index, arr) => {
        return arr.findIndex(t => t.from_ref_no == item.from_ref_no) === index;
      });
    });

    /**
     * Ovrride để Gán lại tham số trước khi save
     * NXCHIEN 30.03.2022
     */
    function getSaveData(mode, action) {
      if (proxy?.offlineReady) {
        proxy.model.ref_id =
          this?.editMode == proxy.$ms.constant.FormState.Add ? commonFunction.newGuid() : proxy.model.ref_id;
      }
      var data = proxy.super('getSaveData', baseDetailVoucher, mode, action);

      data.ref_type = proxy.$ms.constant.RefType.BUTransferDeposit;
      data.ref_type_name = proxy.$t('i18nEnum.RefType.BUTransferDeposit');

      if (!data.bu_commitment_request_ref_no) {
        data.bu_commitment_request_id = null;
      }

      data.VoucherReferences = [...voucherReferenceItems.value];
      data.isSaveOffline = proxy?.offlineReady;
      if (proxy?.offlineReady) {
        let actionMode = this.editMode;
        data = getSaveDataWhenOffline(data, actionMode);
        proxy.model = data; // vì lúc save không load lại trang khi mất mạng => gán lại model để TH nhấn sửa luôn vẫn đúng
        //gắn lại oldData để hoãn
        proxy.super('setOldDataItem', baseDetailVoucher, proxy.model);
      }

      return data;
    }

    /**
     * Custom dữ liệu nếu mất mạng
     */
    function getSaveDataWhenOffline(data, actionMode) {
      // nthien4 28/08/23 bsung tham số để check thêm khi online hay offline
      data.state = !data.state ? proxy.$ms.constant.FormState.Add : data.state;

      // Nếu làm offline => ẩn chức năng sinh chứng từ: case thêm ở đây tránh TH đang thêm thì mất mạng
      hideCheckboxGenerateDrawSalary.value = true;
      isGenerateDrawSalary.value = false;
      // Loại bỏ những dòng empty và delete ở dòng chi tiết
      if (data?.Detail?.length > 0) {
        data.Detail = data.Detail.filter(
          x => x.state != proxy.$ms.constant.ModelState.Delete && x.state != proxy.$ms.constant.ModelState.Empty,
        );
      }
      if (data?.DetailFixedAsset?.length > 0) {
        data.DetailFixedAsset = data.DetailFixedAsset.filter(
          x => x.state != proxy.$ms.constant.ModelState.Delete && x.state != proxy.$ms.constant.ModelState.Empty,
        );
      }
      if (data?.DetailPurchase?.length > 0) {
        data.DetailPurchase = data.DetailPurchase.filter(
          x => x.state != proxy.$ms.constant.ModelState.Delete && x.state != proxy.$ms.constant.ModelState.Empty,
        );
      }
      if (data?.DetailSalary?.length > 0) {
        data.DetailSalary = data.DetailSalary.filter(
          x => x.state != proxy.$ms.constant.ModelState.Delete && x.state != proxy.$ms.constant.ModelState.Empty,
        );
      }
      if (data?.DetailFixedAssetFA?.length > 0) {
        data.DetailFixedAssetFA = data.DetailFixedAssetFA.filter(
          x => x.state != proxy.$ms.constant.ModelState.Delete && x.state != proxy.$ms.constant.ModelState.Empty,
        );
      }
      if (data?.Parallels?.length > 0) {
        data.Parallels = data.Parallels.filter(
          x => x.state != proxy.$ms.constant.ModelState.Delete && x.state != proxy.$ms.constant.ModelState.Empty,
        );
      }
      return data;
    }

    const {clickItemCopyVoucher} = useCopyNewVoucher(proxy, 'Detail');

    /**
     * Action click button Tiện ích
     * NXCHIEN 13.04.2022
     */
    const clickItemHandle = item => {
      switch (item.command) {
        case proxy.$ms.constant.Command.Duplicate:
          item.form = item.form ?? 'BUTransferDepositDetail';
          item.refType = item.refType ?? proxy.$ms.constant.RefType.BUTransferDeposit;
          clickItemCopyVoucher(item);
          break;
        case proxy.$ms.constant.Command.Delete:
          proxy.delete(proxy.model);
          break;
        case 'ShowBUTransfer':
          if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
            delete proxy._formParam.data.IsGenerateData;
          }
          proxy.addVoucher(RefType.BUTransfer, 'BUTransferDetail');
          break;
        case 'ShowBUTransferDeposit':
          if (proxy._formParam && proxy._formParam.data && proxy._formParam.data.IsGenerateData) {
            delete proxy._formParam.data.IsGenerateData;
          }
          proxy.addVoucher(RefType.BUTransferDeposit, 'BUTransferDepositDetail');
          break;
        case proxy.$ms.constant.Command.ViewAccount:
          viewAccount(proxy);
          break;
        case proxy.$ms.constant.Command.GenerateData:
          // kiểm tra có đủ điều kiện sinh rút dự toán không
          // lấy dữ liệu tài khoản grid hạch toán
          let accounts =
            proxy.model.Detail.map(x => {
              return {
                credit_account: x.credit_account,
                cash_withdraw_type_id: x.cash_withdraw_type_id,
              };
            }) || [];
          if (
            accounts.find(
              x =>
                x.credit_account.startsWith(proxy.$ms.constant.AccountNumber.CreditAccountMoney) ||
                x.credit_account.startsWith(proxy.$ms.constant.AccountNumber.BudgetActiveGovernmentMoney) ||
                proxy.$ms.constant.AccountNumber.CreditAccountNotReceipt.find(o => x.credit_account.startsWith(o)),
            ) &&
            accounts.find(
              x =>
                x.cash_withdraw_type_id == proxy.$ms.constant.CashWithDrawType.EstimateAdvance ||
                x.cash_withdraw_type_id == proxy.$ms.constant.CashWithDrawType.EstimateNotYetAdvance ||
                x.cash_withdraw_type_id == proxy.$ms.constant.CashWithDrawType.Expense,
            )
          ) {
            generateBUPlanTransfer();
          } else {
            showError(
              proxy.$tm('i18nBaseForm.Voucher.GenerateVoucher'),
              proxy.$tm('i18nBaseForm.Voucher.GenerateVoucherTitle'),
            );
          }
          break;
        // sinh chi tiền gửi
        case proxy.$ms.constant.Command.GenerateDrawSalary:
          const param = {
            id: proxy.model.ref_id,
            ref_type: proxy.$ms.constant.RefType.BAWithDrawSalary,
          };
          // check xem đã có reference hay chưa
          baWithdrawAPI.getDataByRelationID(param).then(res => {
            // hỏi form show là có xác nhận đồng bộ vào dữ liệu này không
            if (res) {
              // check quyền thêm Sinh chi tiền gửi
              proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
              confirmSync(res);
            } else {
              // check quyền thêm Sinh chi tiền gửi
              proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Add);
              showBAWithdrawSalary(false);
            }
          });
          break;
      }
      proxy.pushTrans(item.command);
    };

    /**
     * Sự kiện ấn nút sửa
     */
    function onEditEvent() {
      if (proxy.offlineReady) {
        // Nếu là sửa khi mất mạng
        proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
      } else {
        // check quyền Sửa (vqphong - 12/12/2022)
        proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);

        const param = {
          id: proxy.model.ref_id,
          ref_type: proxy.$ms.constant.RefType.BAWithDrawSalary,
        };
        baWithdrawAPI.getDataByRelationID(param).then(res => {
          // hỏi form show là có xác nhận sửa vào dữ liệu này không
          if (res) {
            showConfirm(
              `Chuyển khoản kho bạc vào tài khoản tiền gửi hiện thời đã sinh chứng từ Chi tiền gửi trả lương số <span class="color-green">${proxy.$ms.commonFn.processXssValue(
                res.ref_no,
              )}</span>, ngày <span class="color-green">${moment(res.ref_date).format(
                'DD/MM/YYYY',
              )}</span>. Bạn có thực sự muốn sửa Chuyển khoản kho bạc vào tài khoản tiền gửi này không?`,
              `Sửa Chuyển khoản kho bạc vào tài khoản tiền gửi`,
            ).then(answer => {
              switch (answer) {
                case true:
                  proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
                  break;
                case false:
                  break;
              }
            });
          } else {
            proxy.setFormMode(proxy.$ms.constant.FormState.Edit);
          }
        });
      }
    }

    /**
     * xác nhạn có đồng bộ hay không
     * tvhien 03.11.2022
     */
    function confirmSync(data) {
      const title = 'Đồng bộ chứng từ';
      const mess =
        'Bạn có muốn đồng bộ các thông tin đã cập nhật trên Chuyển khoản kho bạc vào tài khoản tiền gửi với chứng từ Chi tiền gửi trả lương số <span class="color-green">' +
        proxy.$ms.commonFn.processXssValue(data.ref_no) +
        '</span> không?';
      showConfirm(mess, title).then(answer => {
        if (answer) {
          // xác nhận là có thì thực hiện show form
          showBAWithdrawSalary(true);
        }
      });
    }

    /**
     * show màn chi tiền gửi trả lương
     * tvhien 03.11.2022
     */
    function showBAWithdrawSalary(isSync) {
      var data = {...proxy.model};
      data.IsGenerateData = true;
      data.IsSyncData = isSync;
      if (isSync) {
        popupUtil.show('BAWithDrawSalaryDetail', {
          mode: proxy.$ms.constant.FormState.Edit,
          formApproveName: 'ApproveVoucherBAWithDrawTab',
          isGenerateData: true,
          data: data,
          options: {
            submit: data => {
              proxy.view({
                id: proxy.model.ref_id,
                mode: proxy.$ms.constant.FormState.View,
              });
            },
          },
        });
      } else {
        popupUtil.show('BAWithDrawSalaryDetail', {
          mode: proxy.$ms.constant.FormState.Add,
          formApproveName: 'ApproveVoucherBAWithDrawTab',
          data: data,
          isGenerateData: true,
          options: {
            submit: data => {
              proxy.view({
                id: proxy.model.ref_id,
                mode: proxy.$ms.constant.FormState.View,
              });
            },
          },
        });
      }
    }

    /**
     * Lấy dữ liệu Rút dự toán CK
     * NNLINH 25.07.2022
     */
    function getDataBUPlanTransfer(data) {
      if (data.withdraw_ref_id) {
        let payload = {id: data.withdraw_ref_id};
        return buPlanWithDrawAPI.getEdit(payload);
      }
      return null;
    }

    /**
     * Sinh giấy rút dự toán
     * NNLINH 25.07.2022
     */
    function generateBUPlanTransfer() {
      let details = proxy.model;
      details.IsGenerateData = true;
      //Kiểm tra có giấy rút
      let dataTrans = getDataBUPlanTransfer(details);
      //Nếu có dữ liệu giấy rút hỏi đồng bộ
      if (dataTrans) {
        // kiểm tra có quyền thêm giấy rút dự toán hay không
        proxy.checkActionPermissionAlert(
          proxy.$ms.constant.Permission.Edit,
          proxy.$ms.constant.SubSystemCode.BuPlanWithDraw,
        );
        dataTrans.then(result => {
          if (result) {
            let mes = proxy.$tm('i18nBaseForm.Voucher.ConfirmSyncVocherContent');
            showConfirm(
              mes.format('Chuyển khoản kho bạc vào tài khoản tiền gửi', result.ref_no),
              proxy.$tm('i18nBaseForm.Voucher.ConfirmSyncVocherTitle'),
            ).then(answer => {
              switch (answer) {
                case true:
                  details.IsSyncData = true;
                  popupUtil.show('BUPlanWithdrawDepositDetail', {
                    mode: proxy.$ms.constant.FormState.Edit,
                    id: proxy.model.withdraw_ref_id,
                    data: details,
                    options: {
                      submit: data => {
                        proxy.view({
                          id: proxy.model.ref_id,
                          mode: proxy.$ms.constant.FormState.View,
                        });
                      },
                    },
                  });
                  break;
                case false:
                  break;
              }
            });
          }
        });
      } else {
        // kiểm tra có quyền thêm giấy rút dự toán hay không
        proxy.checkActionPermissionAlert(
          proxy.$ms.constant.Permission.Add,
          proxy.$ms.constant.SubSystemCode.BuPlanWithDraw,
        );
        //mode add form  rút dự toán tiền gửi
        popupUtil.show('BUPlanWithdrawDepositDetail', {
          mode: proxy.$ms.constant.FormState.Add,
          data: details,
          options: {
            submit: data => {
              proxy.view({
                id: proxy.model.ref_id,
                mode: proxy.$ms.constant.FormState.View,
              });
            },
          },
        });
      }
    }

    //#region Sự kiện select combo

    const selectedAccountingObjectBank = ({newData}) => {
      if (newData) {
        proxy.model.accounting_object_bank_name = newData.bank_name;
      } else {
        proxy.model.accounting_object_bank_name = '';
      }
    };
    //#endregion

    //#region config ẩn hiện cột và sự kiện liên quan đến combo Loại tiền
    const {columnsDataParalell} = useCurrencyShowColumn(proxy, columnParallel);
    const {
      onCurrencyComboboxLoadData,
      selectCurrency,
      onActionBlur,
      totalAmountComputed,
      assignValueCurrency,
      currencyCode,
      isFirst,
    } = useCurrencyCombo(comboboxDataRemote, comboboxLoadData, proxy, 'Detail', 'Parallels');

    /**
     * custom hiển thị thêm cột quy đổi trên grid
     * NXCHIEN 12.06.2022
     */
    function customColumns(columns) {
      isFirst.value = false;
      const currencyCodeValue = proxy.model.currency_code || currencyCode.value;
      if (currencyCodeValue && currencyCodeValue != proxy.$t('i18nEnum.Currency.VND')) {
        columns.forEach(item => {
          if (item.dataField == 'amount') {
            item.visible = true;
          } else if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
        proxy.columnsDataParalell.forEach(item => {
          if (item.dataField == 'amount') {
            item.visible = true;
          } else if (item.dataField == 'amount_oc') {
            item.formatType = proxy.$ms.constant.FormatType.AmountOC;
          }
        });
      }
    }
    //#endregion

    // Cập nhật lại tổng tiền khi xóa dòng dữ liệu chi tiết
    const {
      changeDataBusinessCommon,
      defaultData,
      getDataDefault,
      toggleAboveHandlerGrid,
      bindDefaultData,
      onGridStyleColumn,
      onClickCKC,
      copyDownRow,
      copyActionClick,
      assignDataEmptyToParallel,
      copyDownRowExtend,
    } = useActionGridEditor(proxy);

    getDataDefault(proxy.$ms.constant.RefType.BUTransferDeposit);

    const {
      selectedProject,
      selectedBank,
      selectedAccountingObject,
      onBlurActionDatePicker,
      viewAccount,
    } = useInforCommons();

    // Validate tài khoản và nguồn
    const {onPosted, customUnPostedSuccess} = useValidateBudgetSourceAccount();

    /**
     * Update value khi sửa 1 field trong grids
     * NXCHIEN 13.04.2022
     */
    const changeDataBusiness = ($grid, col, rowIndex, metaData, callbackUpdateRow) => {
      const {dataField} = col;
      const {tracking} = metaData;
      changeDataBusinessCommon($grid, col, rowIndex, metaData, callbackUpdateRow, dataField, tracking);

      // Custom thêm thì switch case ở đây.
    };

    /**
     * Custom gọi hàm sinh dữ liệu
     * tbngoc 20.07.2022
     */
    function customVoucherLoadData(result) {
      if (
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.data.IsGenerateData &&
        (proxy.editMode === proxy.$ms.constant.FormState.Add || proxy.editMode === proxy.$ms.constant.FormState.Edit)
      ) {
        Object.assign(result, {
          Id: proxy._formParam.data.ref_id,
          ParamModeAdd: JSON.stringify({
            RefTypeKey: proxy.$ms.constant.RefType.BUTransferDeposit,
          }),
          IsSyncData: proxy._formParam.data.IsSyncData,
          action: 'DataVoucher',
        });
      } else {
        proxy.super('customVoucherLoadData', baseDetailVoucher, result);
      }
    }

    /**
     * Config tùy chỉnh giao diện
     * NNLINH 25.07.2022
     */
    const getConfigLayout = () => {
      return {
        layouts: [
          {tag: 'BUTransferDepositDetail', name: 'Hạch toán'},
          {tag: 'BUTransferDepositDetailSta', name: 'Thống kê'},
        ],
      };
    };

    /**
     * Override từ base
     * Cập nhật danh sách bên ngoài sau khi xóa bản ghi liên quan bên trong màn hình chi tiết
     * @param {*} param
     * NVTUAN1 26.07.2022
     */
    function afterDeleteRelation(param) {
      const me = this;
      if (param && Array.isArray(param) && param.length) {
        let dataParam = param[0];
        let moduleValue = '';
        switch (dataParam.RefType) {
          //Rút dự toán tiền gửi
          case me.$ms.constant.RefType.BUPlanWithdrawDeposit:
          //Rút dự toán chuyển khoản lương, bảo hiểm
          case me.$ms.constant.RefType.BUPlanWithdrawSalaryTransfer:
            moduleValue = ModuleBuPlanWithDraw;
            break;
          default:
            break;
        }

        if (moduleValue) {
          me.$store.dispatch(`${moduleValue}/updateAfterDeleteRelation`, param);
        }
      }
    }
    /**
     * Enable Button Delete
     *
     */
    const disabledDelete = computed(() => {
      return proxy.editMode != proxy.$ms.constant.FormState.View || proxy.model.is_posted;
    });
    /**
     * Override để custom lại những form cần validate chi tiết theo field gì
     * NNLINH 29.07.2022
     */
    function getMapField() {
      let res = proxy.super('getMapField', baseDetailVoucher); //bank_info_code
      res.forEach(x => {
        if (x.field == 'is_detail_by_bank_account') {
          x.mapField = 'accounting_object_bank_account';
        }
        if (x.field == 'is_detail_by_budget_kind_item') {
          x.mapField = 'budget_sub_kind_item_code';
        }
      });
      return res;
    }

    const {configColumnParalellBUTransferDetail} = useActionParallel();
    /**
     * Override Lấy ra entity hạch toán đồng thời => đoạn này dev cần cấu hình để lấy chính xác entity, tạm lấy theo columns grid hạch toán đồng thời
     * @returns Model hạch toán đồng thời dạng: [{dataField: "field1"},{dataField: "field2"}]
     * NNLINH 02.08.2022
     */
    function getParallelModel() {
      if (!this.gridDetailParallel) {
        return {};
      }
      return configColumnParalellBUTransferDetail;
    }
    /**
     * ghi đè sự kiện sau khi cất thành công
     * tvhien 03.11.2022
     */
    function afterSubmitModeView(result, param) {
      if (proxy.dbOptions && !proxy.dbOptions.PostAfterSave && !proxy.isFromCompareConvert) {
        // check xem có liên kết hay không
        const paramData = {
          id: proxy.model.ref_id,
          ref_type: proxy.$ms.constant.RefType.BAWithDrawSalary,
        };
        baWithdrawAPI.getDataByRelationID(paramData).then(res => {
          // hỏi form show là có xác nhận đồng bộ vào dữ liệu này không
          if (res) {
            // check quyền thêm Sinh chi tiền gửi
            proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
            confirmSync(res);
          } else {
            if (isGenerateDrawSalary.value) {
              // check quyền thêm Sinh chi tiền gửi
              proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Add);
              showBAWithdrawSalary(false);
            }
          }
        });

        // Cập nhật ở danh sánh thu tiền gửi
        let baDepositResult = {...result};
        if (
          proxy.editMode === proxy.$ms.constant.FormState.Add ||
          proxy.editMode === proxy.$ms.constant.FormState.Duplicate
        ) {
          proxy.$store.dispatch('bADeposit/insertItemMultiMaster', baDepositResult);
        } else if (proxy.editMode === proxy.$ms.constant.FormState.Edit) {
          proxy.$store.dispatch('bADeposit/updateItemMultiMaster', baDepositResult);
        }
        proxy.super('afterSubmitModeView', baseDetailVoucher, result, param);

        // lưu cache lại giá trị tự động sinh
        // Check nếu ko phải là sinh chứng từ từ Rút dự toán tiền gửi thì lưu cache giá trị checkbox sinh chứng từ trả lương NHANH3 21.07.2023
        if (!proxy.hideCheckboxGenerateDrawSalary) {
          proxy.$ms.commonFn.setLocalStorage('IsGenerateDrawSalary', isGenerateDrawSalary.value);
        }
      } else {
        proxy.super('afterSubmitModeView', baseDetailVoucher, result, param);
      }
    }

    /**
     * ghi lại sau khi cất thực hiện close
     * tvhien 29.11.2022
     */
    function afterSubmitModeSave(result, param) {
      proxy.saveAndClose = true;
      if (!proxy.isFromCompareConvert && proxy.dbOptions && !proxy.dbOptions.PostAfterSave) {
        // check xem có liên kết hay không
        const paramData = {
          id: proxy.model.ref_id,
          ref_type: proxy.$ms.constant.RefType.BAWithDrawSalary,
        };
        baWithdrawAPI.getDataByRelationID(paramData).then(res => {
          // hỏi form show là có xác nhận đồng bộ vào dữ liệu này không
          if (res) {
            // check quyền thêm Sinh chi tiền gửi
            proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
            confirmSync(res);
          } else {
            if (isGenerateDrawSalary.value) {
              // check quyền thêm Sinh chi tiền gửi
              proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Add);
              showBAWithdrawSalary(false);
            }
          }
        });
        // Check nếu ko phải là sinh chứng từ từ Rút dự toán tiền gửi thì lưu cache giá trị checkbox sinh chứng từ trả lương NHANH3 21.07.2023
        if (!proxy.hideCheckboxGenerateDrawSalary) {
          proxy.$ms.commonFn.setLocalStorage('IsGenerateDrawSalary', isGenerateDrawSalary.value);
        }
        proxy.hide();
      }
    }

    /**
     * Thay đổi giá trị tự động sinh
     * tvhien 08.11.2022
     */
    function changeGenerateDrawSalary() {
      // Check nếu ko phải là sinh chứng từ từ Rút dự toán tiền gửi thì lưu cache giá trị checkbox sinh chứng từ trả lương NHANH3 21.07.2023
      if (!proxy.hideCheckboxGenerateDrawSalary) {
        proxy.$ms.commonFn.setLocalStorage('IsGenerateDrawSalary', isGenerateDrawSalary.value);
      }
    }

    /**
     * Xóa chứng từ ngoài màn hình danh sách thu tiền gửi
     * NNLINH 23.11.2022
     */
    function deleteSuccess(record, result) {
      // Xóa trong module
      record.result = result;
      proxy.$store.dispatch('bADeposit/deleteItemMultiMaster', record);
      // Gán vào để xử lý trong store

      proxy.super('deleteSuccess', baseDetailVoucher, record, result);
    }

    /**
     * ghi đè khi ghi sổ thành công thì sẽ tự động sinh chứng từ
     * tvhien 29.11.2022
     */
    function customPostedSuccess(res, param) {
      if (!proxy.isFromCompareConvert) {
        // check xem có liên kết hay không
        const paramData = {
          id: proxy.model.ref_id,
          ref_type: proxy.$ms.constant.RefType.BAWithDrawSalary,
        };
        baWithdrawAPI.getDataByRelationID(paramData).then(res => {
          // hỏi form show là có xác nhận đồng bộ vào dữ liệu này không
          if (res) {
            // check quyền thêm Sinh chi tiền gửi
            proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Edit);
            confirmSync(res);
          } else {
            if (isGenerateDrawSalary.value) {
              // check quyền thêm Sinh chi tiền gửi
              proxy.checkActionPermissionAlert(proxy.$ms.constant.Permission.Add);
              showBAWithdrawSalary(false);
            }
          }
        });
        // lưu cache lại giá trị tự động sinh
        // Check nếu ko phải là sinh chứng từ từ Rút dự toán tiền gửi thì lưu cache giá trị checkbox sinh chứng từ trả lương NHANH3 21.07.2023
        if (!proxy.hideCheckboxGenerateDrawSalary) {
          proxy.$ms.commonFn.setLocalStorage('IsGenerateDrawSalary', isGenerateDrawSalary.value);
        }
      }
    }
    /** Xử lý dữ liệu khi sinh chứng từ
     * NNLINH 24.11.2022
     */
    async function beforeBindData() {
      const me = proxy;
      if (
        proxy.editMode === proxy.$ms.constant.FormState.Add &&
        proxy._formParam &&
        proxy._formParam.data &&
        proxy._formParam.IsPayrollExpenseGenerateData
      ) {
        // Lấy lại dữ liệu autoID...
        let data = await proxy.loadData('New', {
          mode: proxy.$ms.constant.FormState.Add,
        });
        me.model = proxy._formParam.data;
        me.model.ref_no = data.ref_no;
        me.model.posted_date = proxy.postedDate;
        me.model.ref_date = proxy.postedDate;
        me.model.ref_no = data.ref_no;
        me.model.currency_code = proxy.$t('i18nEnum.Currency.VND');
        me.model.exchange_rate = 1;
        currencyCode.value = me.model.currency_code;
        assignDataEmptyToParallel(proxy);
        await proxy.generateParallel(true, true);
        //gắn lại oldData để hoãn
        //NNLINH 27.12.2022
        proxy.super('setOldDataItem', baseDetailVoucher, proxy.model);
      }
      proxy.super('beforeBindData', baseDetailVoucher);
    }

    const refType = RefType.BUTransferDeposit;

    /**
     * Override sự kiện khi đóng form
     * mở lại form hạch toán chii phí lương khi sinh chứng từ
     * NNLINH 25.11.2022
     */
    function beforeClose(e) {
      if (proxy._formParam.options && typeof proxy._formParam.options.submitData === 'function') {
        proxy._formParam.options.submitData();
      } else {
        proxy.super('beforeClose', baseDetailVoucher, e);
      }
    }

    /**
     * Next chứng từ
     * nthien4 05.12.2022
     */
    async function nextVoucher() {
      const me = proxy;
      let modules = me.getRealModule();
      const gridData = me.$store.getters[`${modules}/items`],
        config = me.$store.getters[`${modules}/_config`];
      if (Object.keys(config).length && Object.keys(gridData).length) {
        const {field} = config;
        const rowData = await me.getNextVoucher();

        let newRef = rowData['ref_type'];
        if (newRef == me.model?.ref_type) {
          me.view({id: rowData[field.key]});
        } else {
          Object.keys(me.$ms.constant.RefTypeMapperDetailName).forEach(item => {
            if (
              (Array.isArray(me.$ms.constant.RefTypeMapperDetailName[item]) &&
                me.$ms.constant.RefTypeMapperDetailName[item].find(x => x == newRef)) ||
              (Number.isInteger(me.$ms.constant.RefTypeMapperDetailName[item]) &&
                me.$ms.constant.RefTypeMapperDetailName[item] == newRef)
            ) {
              popupUtil
                .show(item, {
                  mode: me.$ms.constant.FormState.View,
                  id: rowData[field.key],
                  data: rowData,
                  currentPath: me._currentPath,
                  formApproveName: me._formParam?.formApproveName,
                })
                .then(x => {
                  setTimeout(() => {
                    me.hide();
                  }, 0);
                });
            }
          });
        }
      }
    }

    /**
     * Thực hiện back voucher
     * nthien4 05.12.2022
     */
    async function backVoucher() {
      const me = proxy;
      let modules = me.getRealModule();
      const gridData = me.$store.getters[`${modules}/items`],
        config = me.$store.getters[`${modules}/_config`];
      if (Object.keys(config).length && Object.keys(gridData).length) {
        const {field} = config;
        const rowData = await me.getPreviousVoucher();

        let newRef = rowData['ref_type'];
        if (newRef == me.model?.ref_type) {
          me.view({id: rowData[field.key]});
        } else {
          Object.keys(me.$ms.constant.RefTypeMapperDetailName).forEach(item => {
            if (
              (Array.isArray(me.$ms.constant.RefTypeMapperDetailName[item]) &&
                me.$ms.constant.RefTypeMapperDetailName[item].find(x => x == newRef)) ||
              (Number.isInteger(me.$ms.constant.RefTypeMapperDetailName[item]) &&
                me.$ms.constant.RefTypeMapperDetailName[item] == newRef)
            ) {
              setTimeout(() => {
                me.hide();
              }, 0);

              popupUtil.show(item, {
                mode: me.$ms.constant.FormState.View,
                id: rowData[field.key],
                data: rowData,
                currentPath: me._currentPath,
                formApproveName: me._formParam?.formApproveName,
                isBackRouter: me._formParam.isBackRouter,
              });
            }
          });
        }
      }
    }

    /**
     * @override
     * Lấy module thật
     * nvtoan2 21/11/2023
     */
    function getRealModule() {
      let modules;
      if (proxy._formParam && proxy._formParam.formApproveName) {
        switch (proxy._formParam.formApproveName) {
          case 'ApproveVoucherBUTransferTab':
            modules = 'bUTransfer';
            break;
          case 'ApproveVoucherCAPayment':
            modules = 'cAPayment';
            break;
          case 'ApproveVoucherCAReceiptCustomer':
            modules = 'cAReceiptSale';
            break;
          default:
            modules = 'bADeposit';
            break;
        }
      }
      if (!modules || modules == undefined) {
        modules = 'bADeposit';
      }

      return modules;
    }

    const stepsDynamic = ref([]);
    /**
     * Dữ liệu step
     */
    const steps = ref([
      {
        target: '.step-1',
        header: {
          title: 'Chức năng Hướng dẫn',
        },
        state: ['default'],
        content: 'Xem hướng dẫn nhanh các thao tác trên màn hình chứng từ',
      },
      {
        target: '.step-2',
        header: {
          title: 'Phím tắt',
        },
        state: ['default'],
        content: 'Xem danh sách các phím tắt để thao tác nhanh trên phần mềm',
      },
      {
        target: '.step-3',
        header: {
          title: 'Tùy chỉnh giao diện',
        },
        state: ['default'],
        content: 'Thực hiện tùy chỉnh giao diện chứng từ theo nhu cầu',
      },
      {
        target: '.step-4',
        header: {
          title: 'Trợ giúp',
        },
        state: ['default'],
        content: 'Xem tài liệu hướng dẫn chi tiết nghiệp vụ',
      },

      {
        target: '.ms-tbody td.budget_sub_item_code',
        dataField: 'budget_sub_item_code',
        header: {
          title: 'Nhập Tiểu mục',
        },
        scroll: {
          inline: 'auto',
          marginH: 80,
        },
        state: ['edit'],
        content: `Nhập thông tin Tiểu mục theo từng nội dung chuyển khoản chi tiết`,
      },

      {
        target: '.ms-tbody .row-editor-action.insert',
        header: {
          title: 'Thêm dòng',
        },
        scroll: {},
        state: ['edit'],
        content: `Thêm nội dung chuyển khoản kho bạc vào tài khoản tiền gửi`,
      },

      {
        target: '.ms-tbody .row-editor-action.delete',
        header: {
          title: 'Xóa dòng',
        },
        scroll: {},
        state: ['edit'],
        content: `Xóa nội dung chuyển khoản kho bạc vào tài khoản tiền gửi`,
      },

      {
        target: '.step-close',
        header: {
          title: 'Chức năng',
        },
        state: ['edit'],
        content: `Thực hiện Cất để lưu Chứng từ`,
      },
      {
        target: '.step-5-pos',
        header: {
          title: 'Tiện ích',
        },
        state: ['posted', 'unposted'],
        content: 'Tùy chọn các chức năng khác của chứng từ như: Thêm chứng từ mới, Xem số dư tài khoản,...',
      },
      {
        target: '.step-6-pos',
        header: {
          title: 'Chức năng In',
        },
        state: ['posted', 'unposted'],
        content: `Lựa chọn chứng từ để in hoặc thiết lập tùy chọn in theo lô`,
      },
      {
        target: '.step-7-posted',
        header: {
          title: 'Sửa nhanh',
        },
        state: ['posted'],
        content: `Thực hiện sửa một số thông tin chung trên chứng từ`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Bỏ ghi',
        },
        state: ['posted'],
        content: `Bỏ ghi sổ chứng từ để sửa hoặc xóa chứng từ`,
      },
      {
        target: '.step-7-unposted',
        header: {
          title: 'Chức năng Xóa',
        },
        state: ['unposted'],
        content: `Xóa chứng từ hiện thời`,
      },
      {
        target: '.step-8-unposted',
        header: {
          title: 'Sửa',
        },
        state: ['unposted'],
        content: `Sửa chứng từ hiện thời`,
      },
      {
        target: '.step-close',
        header: {
          title: 'Ghi sổ',
        },
        state: ['unposted'],
        content: `Ghi sổ chứng từ hiện thời`,
      },
    ]);

    onMounted(() => {
      /** Dữ liệu step binding */
      proxy.steps = computed(() =>
        steps.value.filter(x => !x.dataField || proxy.gridDetail?.columnx.some(o => o.dataField == x.dataField)),
      );

      isShowVoucherReference.value = true;
      // Nếu sau muốn check chỉ ref_type nào được phép có tham chiếu
      // isShowVoucherReference.value =
      //   refTypeAcceptVoucherReference.value.includes(refType.value) &&
      //   proxy._formParam.mode === proxy.$ms.constant.FormState.View;
    });

    /**
     * Thay đổi step thì custom
     */
    function changeStep(index, step) {
      switch (step.key) {
        case 1:
          proxy.toggleAbove = true;
          break;
      }
    }

    /**
     * Xóa chứng từ tham chiếu
     * @author NHCUONG 23.06.2023
     */
    function removeVoucherReference(item) {
      voucherReferenceItems.value = voucherReferenceItems.value.filter(x => x.from_ref_id !== item.from_ref_id);
    }

    /**
     * Hiển thị form tham chiếu Phiếu thu
     * @author NHCUONG 23.06.2023
     */
    function showFormVoucherReference() {
      popupUtil.show('VoucherReference', {
        postedDate: proxy.model.posted_date,
        RefTypeView: getRefTypeView(),
        RefIdView: proxy.model.ref_id,
        IsView: true,
      });
    }

    /**
     * Lấy ref type tham chiếu
     * @author NHCUONG 23.06.2023
     */
    function getRefTypeView() {
      let refTypeView = proxy.$ms.constant.RefType.CAReceiptPlanWithdraw;
      switch (refType.value) {
        case proxy.$ms.constant.RefType.CAReceiptPlanWithdraw:
          refTypeView = proxy.$ms.constant.RefType.CAReceiptPlanWithdraw;
          break;
        case proxy.$ms.constant.RefType.BAWithDraw:
        case proxy.$ms.constant.RefType.BAWithdrawPurchase:
        case proxy.$ms.constant.RefType.BAWithDrawFixedAsset:
        case proxy.$ms.constant.RefType.BAWithdrawVendor:
          refTypeView = proxy.$ms.constant.RefType.BUTransferDeposit;
          break;
        case proxy.$ms.constant.RefType.GLGeneralVoucher:
          refTypeView = proxy.$ms.constant.DefaultValue.All;
          break;
        case proxy.$ms.constant.RefType.BUTransferDeposit:
          refTypeView = proxy.$ms.constant.RefType.BUTransferDeposit;
          break;
      }
      return refTypeView;
    }

    /**
     * Hiển thị target link khi xem chứng từ
     * @author NHCUONG 26.06.2023
     */
    function showTargetLink(item) {
      let newItem = {...item, ref_id: item.from_ref_id, ref_no: item.from_ref_no, ref_type: item.from_ref_type};
      proxy.super('showTargetLink', baseDetailVoucher, newItem);
    }

    /**
     * Override lại để custom config
     * NHANH3 20.07.2023
     */
    function customStoreConfig(config) {
      if (config.checkField == 'bank_account') {
        config.checkField = 'bank_account_custom';
      }
      return config;
    }

    /**
     * Override lại hàm check danh mục để xử lý trường hợp đặc biệt
     * NHANH3 20.07.2023
     */
    async function checkExistDictionary(checkField, value, queryMode, storeName) {
      if (!checkField || value == null || value == undefined || value == '00000000-0000-0000-0000-000000000000') {
        return;
      }

      // Biến lưu danh sách dữ liệu lấy từ cache hoặc gọi API
      let recentData = [];
      // Biến lưu giữ liệu tìm thấy
      let data = null;

      // Nếu được lưu vào cache
      if (queryMode == 'local') {
        if (!storeName) return;

        recentData = this.$store.state[storeName].items;
      }
      // Nếu là trường hợp được gọi server kiểm tra
      else if (queryMode == 'remote') {
        recentData = this.resultCheckExist[checkField];
      }

      if (recentData == undefined || recentData == null) {
        return;
      }
      if (checkField == 'bank_account_custom') {
        checkField = 'bank_account';
      }
      data = recentData.find(x => x[checkField] == value) || false;
      return data;
    }

    /**
     * Override custom lại cảnh báo
     * Validate grid hạch toán
     * dqdat11 05.09.2023
     */
    async function validateAccounting() {
      let me = proxy;
      // Xử lý build message
      let invalid = (await me.validateDetail()) || [];
      me.cacheInvalidPosted = [...invalid];
      if (invalid.length && invalid.some(t => t.field.some(x => x == 'is_detail_by_bank_account'))) {
        var mes = `Tài khoản đơn vị nhận không được để trống.`;
        me.invalidPost = invalid;
        me.resetValidateGrid();
      } else {
        return await proxy.super('validateAccounting', baseDetailVoucher);
      }
      return mes;
    }

    /**
     * nthien4 custom lại để case TH mất mạng
     */
    function saveError(error, param, action) {
      // case nếu mất mạng thì show thông báo cất thành công
      if (proxy.offlineReady) {
        // Khi mất mạng, vẫn show cất thành công
        // Chuyển mode về xem
        proxy.editMode = proxy.$ms.constant.FormState.View;
        proxy.$toast.success(proxy.$tm('i18nBaseForm.Message.SaveSuccess'));
      } else {
        proxy.super('saveError', baseDetailVoucher, error, param, action);
      }
    }

    const changeTriggers = shallowRef([
      'project_code',
      'budget_kind_item_code',
      'budget_sub_kind_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'budget_detail_item_code',
      'amount_oc',
      'credit_account',
      'debit_account',
      'budget_source_name',
      'project_expense_code',
      'accounting_object_code',
      'quantity',
    ]);
    const changeTriggersHT = shallowRef([
      'project_code',
      'budget_kind_item_code',
      'budget_sub_kind_item_code',
      'budget_item_code',
      'budget_sub_item_code',
      'budget_source_name',
      'amount_oc',
      'budget_detail_item_code',
      'credit_account',
      'debit_account',
    ]);
    /**
     * Custom tham số xóa chứng từ
     * TPNAM 28.02.2024
     */
    function getParamDeleteDetail(tempArr){
      return [...tempArr.map(({ ref_id, ref_type, ref_no }) => ({ref_id, ref_type, ref_no }))];
    }
    return {
      titleCode,
      viewAccount,
      changeTriggers,
      changeTriggersHT,
      refType,
      layoutTagDetail,
      currentLayout,
      module, // module form cha
      //tên router form danh sách khi đóng sẽ quay lại
      backRouter: '/treasury/transfer',

      toggleAbove, // Value đóng mở thu gọn
      toggleAboveHandler, // Action thu gọn form
      selectedTab, // Value hiển thị tab
      selectedTabHandler, // Xử lý active tab các grid chi tiết

      buttonTransferDeposit,
      buttonPrints,
      // Cấu hình Field trong grid
      columnParallel,

      propsData, // Chứa config các field trong grid

      comboboxLoadData, //  Call API lấy dữ liệu combo
      submitQuickAdd,
      comboboxDataRemote, // Object chưa data của các combo

      // column combo
      projectColumns,
      bankColumns,
      accountColumns,
      currencyColumns,

      clickItemHandle,

      changeDataBusiness,

      getSaveData, // override lấy tham số để save

      //xử lý sự kiện select trên combo
      selectedProject,
      selectedBank,
      selectedAccountingObjectBank,

      columnsDataParalell,
      selectCurrency,
      onActionBlur,
      onCurrencyComboboxLoadData,
      onBankInfoComboboxLoadData,
      onProjectCommonComboboxLoadData,

      customColumns,

      onClickCKC, //click icon ckc
      customVoucherLoadData,
      bindData,
      beforeOpen,

      totalAmountComputed, //Tổng tiền
      defaultData,
      toggleAboveHandlerGrid,
      onGridStyleColumn,
      selectedAccountingObject,
      onBlurActionDatePicker,
      getConfigLayout,
      propsDataParalell,
      quickAddMultiItems,
      assignValueCurrency,
      afterDeleteRelation,
      getMapField,
      getParallelModel,
      currencyCode,
      afterSubmitModeView,
      isGenerateDrawSalary,
      onEditEvent,
      copyDownRow,
      copyActionClick,
      changeGenerateDrawSalary,
      deleteSuccess,
      customPostedSuccess,
      afterSubmitModeSave,
      beforeBindData,
      beforeClose,
      nextVoucher,
      backVoucher,
      subSystemCode,
      steps,
      quickSearchParam,
      onPosted,
      customUnPostedSuccess,

      isShowVoucherReference,
      voucherReferenceItems,
      removeVoucherReference,
      showFormVoucherReference,
      getRefTypeView,
      showTargetLink,

      configAccountingGrid,
      configParallelGrid,
      disabledDelete,
      customStoreConfig,
      checkExistDictionary,
      hideCheckboxGenerateDrawSalary,
      stepsDynamic,
      projectCombo,
      bankInfoCombo,
      saveError,
      validateAccounting,
      copyDownRowExtend,
      getRealModule,
      DBStartDateString: proxy.DBStartDateString,
      getParamDeleteDetail,
      voucherReferenceItemsShow,
      isCacheParam
    };
  },

  computed: {
    ...mapGetters({
      postedDate: ModuleContext + '/PostedDate',
    }),
    offlineReady() {
      if (!this.$store.state[ModuleOfflineWork]) return false;
      return this.$store.state[ModuleOfflineWork].offlineReady;
    },
    projectCombo() {
      return this.projectCombo
        .filter(x => x.object_type == 1)
        .sort(function (a, b) {
          return a.project_code - b.project_code;
        });
    },
  },
};
</script>

<style lang="scss">
.transfer-deposit-detail {
  @import './BUTransferDepositDetail.scss';

  .ms-textarea-item {
    height: 93px !important;
    @include for_breakpoint(desktop-xl) {
      height: 99px !important;
    }
  }
  .title-left {
    display: flex;
    align-items: center;
  }
  .auto-gen {
    display: flex;
    align-items: center;
  }

  .control-title-right.draw {
    width: 115px !important;
    align-items: center;
    display: flex;
    height: calc($input-height + 2px);
  }
  .btn {
    &.icon-button {
      background: none !important;
    }
  }
  .disabled-event {
    pointer-events: none;
    opacity: 0.4;
  }
}
</style>
